/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementDeleteMemberResponse } from './MemberManagementDeleteMemberResponse';

export type MemberManagementDeleteMemberResponseApiRespoonse = {
    data?: MemberManagementDeleteMemberResponse;
    status?: MemberManagementDeleteMemberResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementDeleteMemberResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

